import React, { FC } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import WeatherForecastHomePage from './WeatherForecastHomePage/WeatherForecastHomePage';
import WeatherForecastLocationSearchPage from './WeatherForecastLocationSearchPage/WeatherForecastLocationSearchPage';
import WeatherSettingsPage from './WeatherSettingsPage/WeatherSettingsPage';
import WeatherWarningDetailsPage from './WeatherWarningDetailsPage/WeatherWarningDetailsPage';

// setting this constant here and not using useRouteMatch as it doesn't always work correctly
const weatherForecastBaseUrl = '/maps/weather';
const weatherForecastLocationSearchBaseUrl = `${weatherForecastBaseUrl}/location/search`;

const WeatherForecastLocationSearchRoute = () => {
  const { latitude, longitude, weatherType } = useParams<{
    latitude: string;
    longitude: string;
    weatherType?: 'general' | 'swell';
  }>();

  return (
    <WeatherForecastLocationSearchPage
      latitude={latitude}
      longitude={longitude}
      weatherType={weatherType}
    />
  );
};

const WeatherForecastFeature: FC = () => (
  <Switch>
    <Route
      path={`${weatherForecastLocationSearchBaseUrl}/:latitude/:longitude/:weatherType?`}
      exact
    >
      <WeatherForecastLocationSearchRoute />
    </Route>

    <Route path={`${weatherForecastBaseUrl}/settings`} exact>
      <WeatherSettingsPage />
    </Route>

    <Route path={`${weatherForecastBaseUrl}/warning/:id`} exact>
      <WeatherWarningDetailsPage />
    </Route>

    <Route
      path={`${weatherForecastBaseUrl}/:latitude(-?[0-9.]+)/:longitude(-?[0-9.]+)`}
      exact
    >
      <WeatherForecastHomePage />
    </Route>

    <Route path={weatherForecastBaseUrl} exact>
      <WeatherForecastHomePage />
    </Route>
  </Switch>
);

export default WeatherForecastFeature;
